<template>
  <div class="a-part-of">
    <div class="a-part-of__container">
      <div class="a-part-of__image">
        <!-- image thumbnail or image unavailable -->
        <ImageResponsiveWithErrorWrapper
          :id="image?.id"
          :alt="image?.alt"
          size="post_small_variable_height"
          :is-text-item="isTextItem"
        />
      </div>
      <div class="a-part-of__description">
        <!-- image caption -->
        <div ref="heading" class="a-part-of__description-heading">
          {{ partOfHeading }}
        </div>
        <GuiLink
          v-if="heading"
          :to="to"
          class="a-part-of__heading"
          data-testid="imageCaption"
        >
          <span>{{ heading }}</span>
        </GuiLink>
        <p v-if="subheading" class="a-part-of__subheading">
          {{ subheading }}
        </p>
        <DeaccessionedTag v-if="item.is_deaccessioned" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  GuiLink,
  useLocalization,
  ImageResponsiveWithErrorWrapper
} from "@thegetty-private/getty-ui";
import DeaccessionedTag from "@/components/atoms/deaccessionedTag/index.vue";

export default {
  name: "PartOf",
  components: {
    GuiLink,
    ImageResponsiveWithErrorWrapper,
    DeaccessionedTag
  },

  props: {
    /**
     * The primary text displayed below the image thumbnail
     */
    heading: {
      type: String,
      default: undefined
    },
    /**
     * The object containing the image data
     *
     * @example { id: 1234, alt: 'An image of art', size: 'post_small_variable_height' }
     */
    image: {
      type: Object,
      default: () => {}
    },
    /**
     * The secondary text displayed below the image thumbnail, under heading
     */
    subheading: {
      type: String,
      default: undefined
    },
    /**
     * Boolean indicating whether or not the item contains text exclusively
     */
    isTextItem: {
      type: Boolean,
      default: false
    },
    /**
     * The router-link "to" property
     */
    to: {
      type: Object,
      default: undefined
    },
    /**
     * Whether the item is deaccessioned
     */
    // eslint-disable-next-line vue/prop-name-casing
    is_deaccessioned: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  data() {
    return {
      imgUuid: this.imageUuid,
      // Assign props to item to pass in to SearchCartouche
      item: this.$props
    };
  },
  computed: {
    /**
     * The translated Part of heading
     *
     * @returns {string}
     */
    partOfHeading() {
      return this.translatePart("object_page.part_of");
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
